import { FC } from 'react';
import { red } from '@ant-design/colors';
import { InfoCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { Row } from '@/shared/ui';

type Props = {
  text: string;
};

export const SuspendedBanner: FC<Props> = ({ text }) => {
  return (
    <Wrapper justifyContent="center">
      <InfoCircleOutlined />
      {text}
    </Wrapper>
  );
};

const Wrapper = styled(Row)`
  width: 100%;
  font-size: 12px;
  padding: 5px;
  background: ${red[7]}};
  color: #fff;
  text-align: center;
  position: sticky;
`;
